import styled from "styled-components";

export const MainBox=styled.div`
display: flex;
border: 1px solid transparent;
margin-top: 7%;
width: 98%;
height: 350px;


`

;

export const Head=styled.h2`
font-size: larger;
margin: 3% 0% 1% 0%;

`

export const MainFlex=styled.div`
display: flex;

`

export const Flex=styled.div`
flex: 1;

`;


export const LowerBox=styled.div`
 margin:1%;
`;

export const ImgPoster=styled.img` 
box-sizing: border-box;
width: 100%;
height: 100%;
`;

export const Para=styled.p` 
font-size: large;
color: grey;
margin: 10px;
`;

export const Blue=styled.h4` 
color:blue
`;

export const GridCard=styled.div` 
display: grid;
grid-template-columns: repeat(3,1fr);
border: 1px solid transparent;
margin: 15px;
height: 200px;
gap:10% 2%;
`;

export const CardImg=styled.img` 
border: 1px solid grey;
width: 80px;
`;

export const CardBox=styled.div` 
display: flex;
border: 1px solid lightgrey;
`;